import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';

import ExploreEventsListing from '@/components/_events/ExploreEventsListing.tsx';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import { ExploreLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

const Club = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableClubFynn = useFlag('clubFynn');

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableClubFynn) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <ExplorePage isSubPage title="explore:club_fynn">
      <ExploreEventsListing types={['dj']} />
    </ExplorePage>
  );
};

export const Route = createFileRoute('/explore/club-fynn')({
  component: () => (
    <ExploreLayout title="explore:club_fynn">
      <Club />
    </ExploreLayout>
  ),
});
